import {Component, OnInit,Injectable, Inject} from 'ng-metadata/core';
import {TagsService, TagItem} from '../tags.service';

@Injectable()
export class TagsSearchBarService {
    constructor() {
    }
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsSearchBar/tagsSearchBar.service.ts